import './App.less';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import AppOverview from "./pages/app/AppOverview";
import AppRoot from "./pages/app/AppRoot";
import PageLayout from "./pages/home/PageLayout";
import AppDeployments from "./pages/app/AppDeployments";
import EnvironmentRoot from "./pages/environment/EnvironmentRoot";
import EnvironmentInfrastructure from "./pages/environment/EnvironmentInfrastructure";
import Templates from "./pages/template/Templates";
import ResourceList from "./pages/resource/Resource";
import CreateFromTemplate from "./pages/environment/EnvironmentFromTemplate";
import EnvironmentSettingsGeneral from './pages/environment/EnvironmentSettingsGeneral';
import EnvironmentApps from './pages/environment/EnvironmentApps';
import ProjectRoot from './pages/project/ProjectRoot';
import EnvironmentDeployments from './pages/environment/EnvironmentDeployments';
import Login from './pages/auth/Login';
import AuthRoot from './pages/auth/AuthRoot';
import Signup from './pages/auth/Signup';
import SetPassword from './pages/auth/SetPassword';
import EmailVerify from './pages/auth/EmailVerified';
import PrivateOutlet from './components/auth/PrivateOutlet';
import PublicOutlet from './components/auth/PublicOutlet';
import ResetPassword from './pages/auth/ResetPassword';
import ResetPasswordRequest from './pages/auth/ResetPasswordRequest';
import ProjectAdminRoot from './pages/admin/ProjectAdminRoot';
import ProjectSettingsRoot from './pages/project/ProjectSettingsRoot';
import ProjectEnvironments from './pages/project/ProjectEnvironments';
import EnvironmentSettingsRoot from './pages/environment/EnvironmentSettingsRoot';
import EnvironmentSettingsInfrastructure from './pages/environment/EnvironmentSettingsInfrastructure';
import EnvironmentSettingsDeployments from './pages/environment/EnvironmentSettingsDeployments';
import ProjectNew from './pages/project/ProjectNew';
import PricingPlans from './pages/billing/PricingPlans';
import AppSettingsRoot from './pages/app/AppSettingsRoot';
import AppSettingsEnvironmentVars from './pages/app/AppSettingsEnvironmentVars';
import AppSettingsScaling from './pages/app/AppSettingsScaling';
import AppSettingsDeployments from './pages/app/AppSettingsDeployments';
import AppSettingsDangerZone from './pages/app/AppSettingsDangerZone';
import AppPipelineBuilds from './pages/app/AppPipelineBuilds';
import ProjectSettingsGeneral from './pages/project/ProjectSettingsGeneral';
import ProjectSettingsMembers from './pages/project/ProjectSettingsMembers';
import ProjectSettingsBilling from './pages/project/ProjectSettingsBilling';
import ProjectAdminGit from './pages/admin/ProjectAdminGit';
import ProjectAdminCloud from './pages/admin/ProjectAdminCloud';
import ProjectAdminContainer from './pages/admin/ProjectAdminContainer';
import ProjectAdminSlack from './pages/admin/ProjectAdminSlack';
import ResourceRoot from './pages/resource/ResourceRoot';
import ResourceOverview from './pages/resource/ResourceOverview';
import ResourceSettingsRoot from './pages/resource/ResourceSettingsRoot';
import ResourceSettingsGeneral from './pages/resource/ResourceSettingsGeneral';
import ResourceSettingsDangerZone from './pages/resource/ResourceSettingsDangerZone';
import ResourceDeployments from './pages/resource/ResourceDeployments';
import EnvironmentAddApp from './pages/environment/EnvironmentAddApp';
import EnvironmentDeployApp from './pages/environment/EnvironmentDeployApp';
import EnvironmentDeployResource from './pages/environment/EnvironmentDeployResource';
import AppSettingsGit from './pages/app/AppSettingsGit';
import ResourceSettingsGit from './pages/resource/ResourceSettingsGit';
import { env } from "./env";
import EnvironmentInfraDeploymentDetails from './pages/environment/EnvironmentInfraDeploymentDetails';
import EnvironmentAppDeploymentDetails from './pages/environment/EnvironmentAppDeploymentDetails';
import EnvironmentRunningTemplates from './pages/environment/EnvironmentRunningTemplates';
import { notification } from 'antd';
import Welcome from './pages/home/Welcome';
import ProjectSettingsUsage from './pages/project/ProjectSettingsUsage';
import MetaTag from './components/MetaTag';
import ProjectsRoot from './pages/projects/ProjectsRoot';
import ProjectsOverview from './pages/projects/ProjectsOverview';
import AppSettingsCustomDomain from './pages/app/AppSettingsCustomDomain';
import ResourceSettingsCustomDomain from './pages/resource/ResourceSettingsCustomDomain';
import ResourcePipelineBuilds from './pages/resource/ResourcePipelineBuilds';
import PipelineBuildDetails from './components/PipelineBuildDetails';
import CostDashboard from './pages/dashboards/CostDashboard';
import PageNotFound from './pages/home/PageNotFound';
import ProjectSettingsCostReport from './pages/project/ProjectSettingsCostReport';

const App = () => {
  // Configure notification component
  notification.config({
    duration: 6
  });

  // Redirect to the old portal if state = redirect:portal
  const params = new URLSearchParams(window.location.search);
  const state = params.get("state") || "";
  const code = params.get("code") || "";
  const type = params.get("type") || "";

  if (state === "redirect:portal") {
    window.location.href = `${env.REACT_APP_OLD_PORTAL_URL}/login?code=${code}&state=${state}&type=${type}`;
  }

  return (
    <Router>
      <MetaTag defaultTags={true} />
      <Routes>
        <Route element={<PublicOutlet />}>
          <Route path='/' element={<Navigate to="/auth/login" />} />
          <Route path="auth" element={<AuthRoot />}>
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<Signup />} />
            <Route path="signup/verify/:email/:code" element={<EmailVerify />} />
            <Route path="set-password/:email/:code" element={<SetPassword />} />
            <Route path="reset-password" element={<ResetPasswordRequest />} />
            <Route path="reset-password/:email/:code" element={<ResetPassword />} />
          </Route>
          <Route element={<PageLayout />}>
            <Route path="templates" element={<Templates />} />
            <Route path="templates/new" element={<CreateFromTemplate />} />
          </Route>

          {/* Backward compatibility with the old implementation */}
          <Route path="/" element={<AuthRoot />}>
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<Signup />} />
            <Route path="account/verify/:email/:code" element={<EmailVerify />} />
            <Route path="set-password/:email/:code" element={<SetPassword />} />
            <Route path="reset-password" element={<ResetPasswordRequest />} />
            <Route path="account/reset/:email/:code" element={<ResetPassword />} />
          </Route>
        </Route>
        <Route element={<PrivateOutlet />}>
          <Route element={<PageLayout />}>

            {/* Projects */}
            <Route path="projects" element={<ProjectsRoot />} >
              <Route index element={<ProjectsOverview />} />
            </Route>

            {/* Project */}
            <Route path="projects/:projectId" element={<ProjectRoot />}>
              <Route index element={<ProjectEnvironments />} />
              <Route path="environments" element={<ProjectEnvironments />} />
              <Route path="admin" element={<ProjectAdminRoot />}>
                <Route index element={<ProjectAdminGit />} />
                <Route path="git" element={<ProjectAdminGit />} />
                <Route path="cloud" element={<ProjectAdminCloud />} />
                <Route path="container" element={<ProjectAdminContainer />} />
                <Route path="slack" element={<ProjectAdminSlack />} />
              </Route>
              <Route path="settings" element={<ProjectSettingsRoot />}>
                <Route index element={<ProjectSettingsGeneral />} />
                <Route path="general" element={<ProjectSettingsGeneral />} />
                <Route path="usage" element={<ProjectSettingsUsage />} />
                <Route path="cost-report" element={<ProjectSettingsCostReport />} />
                <Route path="members" element={<ProjectSettingsMembers />} />
                <Route path="billing" element={<ProjectSettingsBilling />} />
              </Route>
            </Route>
            <Route path="templates" element={<Templates />} />
            <Route path="welcome" element={<Welcome />} />
            <Route path="projects/new" element={<ProjectNew />} />
            <Route path="templates/new" element={<CreateFromTemplate />} />

            <Route path="projects/:projectId">
              {/* Environments */}
              <Route path="environments/:envId" element={<EnvironmentRoot />}>
                <Route index element={<EnvironmentApps />} />
                <Route path="apps" element={<EnvironmentApps />} />
                <Route path="apps/new" element={<EnvironmentAddApp />} />
                <Route path="apps/:serviceName/deploy" element={<EnvironmentDeployApp />} />
                <Route path="infrastructure" element={<EnvironmentInfrastructure />} />
                <Route path="infrastructure/resources" element={<ResourceList />} />
                <Route path="infrastructure/resources/:resourceId/deploy" element={<EnvironmentDeployResource />} />
                <Route path="deployments" element={<EnvironmentDeployments />} />
                <Route path="deployments/infrastructure/:deploymentId" element={<EnvironmentInfraDeploymentDetails />} />
                <Route path="deployments/apps/:clusterId/:namespace/:appName/:deploymentId" element={<EnvironmentAppDeploymentDetails />} />
                <Route path="active-templates" element={<EnvironmentRunningTemplates />} />
                <Route path="dashboards" element={<CostDashboard />} />
                <Route path="settings" element={<EnvironmentSettingsRoot />}>
                  <Route index element={<EnvironmentSettingsGeneral />} />
                  <Route path="general" element={<EnvironmentSettingsGeneral />} />
                  <Route path="infrastructure" element={<EnvironmentSettingsInfrastructure />} />
                  <Route path="deployments" element={<EnvironmentSettingsDeployments />} />
                </Route>
              </Route>

              {/* Apps */}
              <Route path="environments/:envId/apps/:clusterId/:namespace/:appName" element={<AppRoot />}>
                <Route index element={<AppOverview />} />
                <Route path="overview" element={<AppOverview />} />
                <Route path="deployments" element={<AppDeployments />} />
                <Route path="pipeline" element={<AppPipelineBuilds />} />
                <Route path="pipeline/:pipelineId/build/:buildId" element={<PipelineBuildDetails />} />
                <Route path="settings" element={<AppSettingsRoot />}>
                  <Route index element={<AppSettingsEnvironmentVars />} />
                  <Route path="environment" element={<AppSettingsEnvironmentVars />} />
                  <Route path="domain" element={<AppSettingsCustomDomain />} />
                  <Route path="git" element={<AppSettingsGit />} />
                  <Route path="scaling" element={<AppSettingsScaling />} />
                  <Route path="deployments" element={<AppSettingsDeployments />} />
                  <Route path="danger-zone" element={<AppSettingsDangerZone />} />
                </Route>
              </Route>

              {/* Resources */}
              <Route path="environments/:envId/resources/:resourceName" element={<ResourceRoot />}>
                <Route index element={<ResourceOverview />} />
                <Route path="overview" element={<ResourceOverview />} />
                <Route path="pipeline" element={<ResourcePipelineBuilds />} />
                <Route path="pipeline/:pipelineId/build/:buildId" element={<PipelineBuildDetails />} />
                <Route path="deployments" element={<ResourceDeployments />} />
                <Route path="settings" element={<ResourceSettingsRoot />}>
                  <Route index element={<ResourceSettingsGeneral />} />
                  <Route path="general" element={<ResourceSettingsGeneral />} />
                  <Route path="git" element={<ResourceSettingsGit />} />
                  <Route path="domain" element={<ResourceSettingsCustomDomain />} />
                  <Route path="danger-zone" element={<ResourceSettingsDangerZone />} />
                </Route>
              </Route>
            </Route>

            <Route path="/pricing/:action" element={<PricingPlans />} />
            <Route path="*" element={<PageNotFound />} />
          </Route>
        </Route>
      </Routes>
    </Router >
  );
};

export default App;